// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const withdrawalPagoMovilService = async (data: Record<string, unknown>) => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_WITHDRAWAL}`, data);
};
